import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {  addDepots, getDepotsList, editDepots, depotsEditStatus, depotsDelete } from "../../helpers/api";
import { ADD_DEPOTS, GET_DEPOTS_LIST, EDIT_DEPOTS, EDIT_DEPOTS_STATUS, DELETE_DEPOTS } from "./actionTypes";
import { depotsListResponce,  } from "./actions";

//Include Both Helper File with needed methods
import { showToast } from "../toast/actions";


/**
 * Generator function that adds depots to the system.
 * @param {object} payload - The payload object containing the data and token.
 * @param {object} success - The success callback function.
 * @param {object} failure - The failure callback function.
 * @returns None
 */
function* depotsAdd({ payload: { data}, success, failure}){

  try {
    const response = yield call(addDepots, data);
    if (response){
      yield put(showToast({
        message: response?.message,
        type: 'success'
      }));
      success(response)
    }
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));
    
  }
}


/**
 * Generator function that retrieves a list of depots using the provided token.
 * @param {Object} payload - The payload object containing the token.
 * @param {string} payload.token - The authorization token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* depotsList({ payload: { data }, success, failure}){

  try {
    const responce = yield call(getDepotsList, data)
    if (responce){
      yield put(depotsListResponce(responce));
      success(responce)
    }
    
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));
    
  }

}

/**
 * Generator function that handles editing depots.
 * @param {object} payload - The payload object containing the id, data, and token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* editdepots({ payload: { id, data}, success, failure}){

  try {
    const response = yield call(editDepots, id, data);
    if (response){
      yield put(showToast({
        message: response?.message,
        type: 'success'
      }));
      success(response)

    }
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }
}

/**
 * Generator function that handles editing the status of a depot.
 * @param {object} payload - The payload object containing the id, data, and token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* depotsEditstatus({ payload: { id, data}, success, failure}){

  try {
    const response = yield call(depotsEditStatus, id, data);
    if (response){
      yield put(showToast({
        message: response?.message,
        type: 'success'
      }));
      success(response)

    }
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }
}

/**
 * Generator function that handles the deletion of a depot.
 * @param {object} payload - The payload object containing the id, data, and token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* depotsdelete({ payload: { id }, success, failure}){
  try {
    const response = yield call(depotsDelete, id);
    if (response){
      yield put(showToast({
        message: response?.message,
        type: 'success'
      }));
      success(response)

    }
  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }
}





function* Depots() {
     yield takeEvery(ADD_DEPOTS, depotsAdd);
     yield takeEvery(GET_DEPOTS_LIST, depotsList);
    yield takeEvery(EDIT_DEPOTS, editdepots);
    yield takeEvery(EDIT_DEPOTS_STATUS, depotsEditstatus);
    yield takeEvery(DELETE_DEPOTS, depotsdelete);
}

export default Depots;
